import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchCouponHistory = createAsyncThunk(
  "couponHistory/fetchCouponHistory",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/admin/coupon-records", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const couponHistorySlice = createSlice({
  name: "couponHistory",
  initialState: {
    couponHistories: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCouponHistory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCouponHistory.fulfilled, (state, action) => {
        state.status = "success";
        state.couponHistories = action.payload.data;
      })
      .addCase(fetchCouponHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default couponHistorySlice.reducer;
